import { initEvents, initScreen, initPlatform, initUser } from './initialData';

export const initDmpgDataLayer = ({ events, platform, screen, user } = {}) => {
  if (typeof window !== 'undefined') {
    window.dmpgDl = window.Cms.dmpgDl ?? {
      events: events ?? initEvents,
      screen: screen ?? initScreen,
      platform: platform ?? initPlatform,
      user: user ?? initUser
    };
  }

  return window?.dmpgDl;
};
